// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.general-details-container {
  padding: 20px;
  max-width: none;
  margin: 0;
}

.general-details-accordion .mat-expansion-panel {
  margin-bottom: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.general-details-accordion .mat-expansion-panel .mat-expansion-panel-header {
  padding: 16px 24px;
}
.general-details-accordion .mat-expansion-panel .mat-expansion-panel-header .mat-panel-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.general-details-content {
  padding: 16px 24px 24px;
}
.general-details-content .description-section h4 {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 500;
  color: #34495e;
}
.general-details-content .description-section .description-display {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.general-details-content .description-section .description-display .description-text {
  flex: 1;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 4px solid #3498db;
  font-size: 14px;
  line-height: 1.5;
  min-height: 60px;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.general-details-content .description-section .description-edit .description-field {
  width: 100%;
  margin-bottom: 16px;
}
.general-details-content .description-section .description-edit .description-field textarea {
  resize: vertical;
  min-height: 100px;
}
.general-details-content .description-section .description-edit .description-edit-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-start;
}

.roles-content {
  padding: 16px 24px 24px;
}
.roles-content .creator-section {
  margin-bottom: 24px;
}
.roles-content .creator-section .creator {
  font-size: 14px;
  color: #2c3e50;
}
.roles-content .creator-section .creator .username {
  font-weight: 500;
}
.roles-content .roles-container .role-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  gap: 40px;
}
.roles-content .roles-container .role-row .role-section {
  flex: 1;
  min-width: 200px;
}
.roles-content .roles-container .role-row .role-section .role-label, .roles-content .roles-container .role-row .role-section .added-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
  display: block;
  text-transform: lowercase;
}
.roles-content .roles-container .role-row .role-section .role-label .asterisk, .roles-content .roles-container .role-row .role-section .added-label .asterisk {
  color: #e74c3c;
  margin-left: 2px;
}
.roles-content .roles-container .role-row .role-section .added-label {
  color: #666;
}
.roles-content .roles-container .role-row .role-section .role-input-container {
  width: 100%;
  max-width: 300px;
}
.roles-content .roles-container .role-row .role-section .chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.roles-content .roles-container .role-row .role-section .chips-container mat-chip-set {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.roles-content .roles-container .role-row .role-section .chips-container mat-chip {
  background-color: #1976d2;
  color: white;
  border-radius: 16px;
  font-size: 13px;
  padding: 6px 12px;
}
.roles-content .roles-container .role-row .role-section .chips-container mat-chip mat-icon[matChipRemove] {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-left: 4px;
  cursor: pointer;
  opacity: 0.8;
}
.roles-content .roles-container .role-row .role-section .chips-container mat-chip mat-icon[matChipRemove]:hover {
  opacity: 1;
}

::ng-deep .roles-container app-azure-ad-search .mat-mdc-form-field {
  width: 100%;
}
::ng-deep .roles-container app-azure-ad-search .mat-mdc-form-field .mat-mdc-form-field-flex {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0;
}
::ng-deep .roles-container app-azure-ad-search .mat-mdc-form-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  padding: 8px 12px;
}
::ng-deep .roles-container app-azure-ad-search .mat-mdc-form-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix input {
  font-size: 14px;
  color: #333;
}
::ng-deep .roles-container app-azure-ad-search .mat-mdc-form-field .mat-mdc-form-field-flex .mat-mdc-form-field-infix input::placeholder {
  color: #999;
  font-style: italic;
}
::ng-deep .roles-container app-azure-ad-search .mat-mdc-form-field .mat-mdc-form-field-underline {
  display: none;
}
::ng-deep .roles-container app-azure-ad-search .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.container-vertical {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.search-box app-azure-ad-search {
  width: 100%;
}

.selected-users {
  margin-top: 8px;
}

@media (max-width: 768px) {
  .general-details-container {
    padding: 16px;
  }
  .general-details-accordion .mat-expansion-panel-header {
    padding: 12px 16px;
  }
  .general-details-content,
  .roles-content {
    padding: 12px 16px 16px;
  }
  .description-display {
    flex-direction: column;
    gap: 8px;
  }
  .description-display .description-text {
    margin-bottom: 0;
  }
  .description-edit-buttons {
    flex-direction: column;
    gap: 8px;
  }
  .description-edit-buttons button {
    width: 100%;
  }
  .roles-container .role-row {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
  }
  .roles-container .role-row .role-section {
    min-width: auto;
  }
  .roles-container .role-row .role-section .role-input-container {
    max-width: none;
  }
  .roles-container .role-row .role-section .chips-container mat-chip {
    font-size: 12px;
    padding: 4px 8px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
